import { Flex } from 'antd';
import { useMapLanguageToCountry } from '@evimo/hooks/useLanguageMapping';
import { Language } from '@evimo/types/enums/language';

type FlagIconProps = {
  language: Language;
  size?: number;
};

export const FlagIcon: React.FC<FlagIconProps> = ({ language, size }) => {
  const countryCode = useMapLanguageToCountry(language);
  const code = countryCode.toLowerCase();
  const px = size ?? 24;

  return (
    <Flex
      align="center"
      justify="center"
      style={{
        width: size ?? 20,
        height: size ?? 20,
        borderRadius: '50%',
        overflow: 'hidden',
        border: '1px solid #e5e7eb',
        flexShrink: 0,
      }}
    >
      <img
        src={`https://flagicons.lipis.dev/flags/1x1/${code}.svg`}
        width={px}
        height={px}
        alt={language}
        style={{
          objectFit: 'cover',
        }}
      />
    </Flex>
  );
};
